var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 51,
    viewBox: "0 0 49 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4838 31.9443C43.4838 31.9443 33.7638 38.0068 33.5087 38.0693L18.5238 41.4443C18.3588 41.4756 18.1938 41.5068 18.0138 41.5068H10.8438V33.3818L17.5788 29.335C17.9388 29.1162 18.3588 29.0068 18.7788 29.0068H27.8538C29.8788 29.0225 29.8638 32.7256 27.8538 32.7412H19.0188C18.5838 32.7412 18.2238 33.1787 18.2238 33.7256C18.2238 34.2725 18.5838 34.71 19.0188 34.71H32.0387C32.1588 34.71 42.0888 28.5225 42.0888 28.5225C42.2988 28.3975 42.5388 28.3193 42.7638 28.3193C44.4738 28.3506 44.8488 31.1787 43.4838 31.96V31.9443Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23812 30.96H6.79313C5.91499 30.96 5.20312 31.7015 5.20312 32.6162V41.7412C5.20312 42.6559 5.91499 43.3975 6.79313 43.3975H9.23812C10.1163 43.3975 10.8281 42.6559 10.8281 41.7412V32.6162C10.8281 31.7015 10.1163 30.96 9.23812 30.96Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4237 15.1475C40.4237 20.71 36.1037 25.21 30.7638 25.21C17.9537 24.6787 17.9537 5.61621 30.7638 5.08496C36.1037 5.08496 40.4237 9.58496 40.4237 15.1475Z",
    fill: "#8CC947",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4655 18.5854C33.0005 19.0563 32.3418 19.3389 31.4635 19.4599V20.8054H30.3139V19.5003C29.3323 19.4465 28.1698 19.1236 27.4336 18.5316L28.0665 17.0651C28.6736 17.536 29.526 17.8454 30.301 17.9127V15.908C29.3323 15.6389 28.5702 15.464 27.9632 14.7105C27.3432 13.8898 27.4982 12.4367 28.2861 11.6968C28.751 11.2259 29.4227 10.9299 30.301 10.8222V9.49023H31.4505V10.7953C32.3934 10.876 33.1813 11.1182 33.8013 11.5353L33.2201 13.0153C32.6388 12.6655 32.0576 12.4637 31.4505 12.3964V14.4415C32.4063 14.6971 33.1555 14.8585 33.7625 15.612C34.3825 16.4193 34.2275 17.8589 33.4526 18.5854H33.4655ZM29.681 13.8091C29.8231 13.9436 30.0427 14.0513 30.3139 14.132V12.4233C29.6423 12.5309 29.1385 13.2844 29.681 13.8091ZM32.0963 17.5494C32.613 16.944 32.1351 16.3923 31.4764 16.204V17.8589C31.7476 17.7916 31.9672 17.684 32.0963 17.5494Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.10f52f548ec296ba407b64cd835a4b76.svg";
export { ForwardRef as ReactComponent };